import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { STATUS } from '../../models/loading-status.enum';
import { AuthService } from '../../../../services/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { authorisationFormConfig, submitButtonLabel } from './auth.config';
import { EoFormComponent } from 'ngx-eo-web-components';
import { el } from 'date-fns/locale/el';
import { format } from 'date-fns/format';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  @ViewChild('eoForm') eoForm?: EoFormComponent;
  appTitle = environment.appTitle;
  appSubtitle = environment.appSubtitle;
  appVersion = environment.appVersion;
  appUrl = environment.appUrl;
  rootFolder = environment.ROOT_FOLDER;

  today = format(new Date(), 'iiii dd/MM/yyyy', { locale: el });
  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
      window.location.href.indexOf('local') !== -1
      ? true
      : false;
  STATUS = STATUS;
  subscriptions: Subscription[] = [];

  formConfig = [...authorisationFormConfig];
  getFormConfig() {
    return this.formConfig;
  }

  onSubmit($event: any) {
    if (!$event?.login) return;

    let username = $event.login.username ?? '';
    let password = $event.login.password ?? '';
    this.authService.fetchToken(username, password);
  }

  isSubmitLoading(): boolean {
    return this.authService.loginStatus$?.getValue() === STATUS.loading;
  }

  getSubmitButtonLabel(): string {
    return submitButtonLabel;
  }

  getSuccessSub$() {
    return this.authService.tokenStatus$
      .pipe(filter((s) => {
        if (s === STATUS.pending) {
          this.router.navigate(['/logout']);
        }
        return s === STATUS.success;
      }))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  onSubmitSuccess(): void {
    this.showSuccessMessage();
  }

  showSuccessMessage(): void {
    this.eoForm?.form.reset();;
    this.router.navigate(['home']);
  }

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {

  }

  ngOnInit(): void {
    this.subscriptions = [this.getSuccessSub$()];
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach((s) => s.unsubscribe());
  }
}
